import * as R from 'ramda';
import React from 'react';
// components
import { Label } from '../label';
// helpers/constants
import * as G from '../../helpers';
// icons
import * as I from '../../svgs';
// ui
import { Box, Flex } from '../../ui';
//////////////////////////////////////////////////

const mainDarkColor = G.getTheme('dark.mainDark');
const offWhiteColor = G.getTheme('colors.offWhite');

export const FormGroupTitleMultiple = (props) => (
  <Flex
    bg={offWhiteColor}
    position='relative'
    color={mainDarkColor}
    justifyContent={R.propOr('start', 'jc', props)}
  >
    <Box
      pl={15}
      lineHeight='30px'
      bg={offWhiteColor}
      color={mainDarkColor}
      mb={R.propOr(5, 'mb', props)}
      height={R.propOr(30, 'height', props)}
    >
      <Label
        fontWeight={700}
        endAction={props.onClickLabel}
        frontAction={props.onClickFrontLabel}
        endIcon={R.propOr(null, 'endIcon', props)}
        endLabel={R.propOr(null, 'endLabel', props)}
        frontIcon={R.propOr(null, 'frontIcon', props)}
        frontLabel={R.propOr(null, 'frontLabel', props)}
      >
        {props.title}
      </Label>
    </Box>
    {
      props.showArrowToggle &&
      <Box
        top='8px'
        right={16}
        position='absolute'
        onClick={props.onToggleFormGroup}
        transform={R.and(props.isOpened, 'rotate(180deg)')}
      >
        {I.arrowDownSimple(offWhiteColor)}
      </Box>
    }
    {props.children}
  </Flex>
);
